import { useEffect, useState } from 'react'
import { getStateFromUrl } from 'shared/lib/getStateFromUrl'
import { useUrlStateManagerDefault } from 'shared/hooks/useUrlStateManager'
import { useContext } from '../useContext'
import { useContextFilters } from '../useContextFilters'
import { useContextLocation } from '../useContextLocation'
import { useContextSpyLaunchSettings } from '../useContextSpyLaunchSettings1'
import { useContextSpyId } from '../useContextSpyId'
import { useReadMonitorByIdQuery } from 'services/monitor'
import { spyLaunchSettingsConvertFromApiValue } from 'shared/lib/spyLaunchSettingsConvertFromApiValue'
import { useContextLocationSearchString } from '../useContextLocationSearchString'
import { filtersConvertFromApi } from 'shared/lib/filtersConvertFromApi'

export const useContextManager = () => {
    const {
        urlState,
        setUrlState
    } = useUrlStateManagerDefault()

    const [readMonitorByIdQueryParams, setReadMonitorByIdQueryParams] = useState<any>(undefined)
    const [readMonitorByIdOptions, setReadMonitorByIdOptions] = useState<any>(
        {
            skip: true
        }
    )

    const {
        data: readMonitorByIdQueryData,
        isLoading: readMonitorByIdQueryIsLoading
    } = useReadMonitorByIdQuery(readMonitorByIdQueryParams, readMonitorByIdOptions);


    const {
        context,
        setContext,
        updateContext
    } = useContext()

    const {
        selectContextSpyId,
        setContextSpyId
    } = useContextSpyId()

    const {
        selectContextLocation,
        setContextLocation
    } = useContextLocation()

    const {
        selectContextLocationSearchString,
        setContextLocationSearchString
    } = useContextLocationSearchString()


    const {
        selectContextFilters,
        setContextFilters
    } = useContextFilters()

    const {
        selectContextSpyLaunchSettings,
        setContextSpyLaunchSettings
    } = useContextSpyLaunchSettings()   

    useEffect(() => {
        const stateFromUrl = getStateFromUrl(urlState)
        const newState = {
             ...(stateFromUrl.spyId && {spyId : stateFromUrl.spyId.value})
        }

        updateContext(newState)
    }, [])


    useEffect(() => {
        setReadMonitorByIdQueryParams({
            ...readMonitorByIdQueryParams,
            monitorId: selectContextSpyId
        })

        setReadMonitorByIdOptions(
            {
                ...readMonitorByIdOptions,
                skip: selectContextSpyId === undefined,
            }
        )
    }, [
        selectContextSpyId
    ])

    useEffect(() => {
        //CHECK EQ
    }, [
        urlState
    ])

    useEffect(() => {
        //CHECK EQ
    }, [
         context
    ]) 

    useEffect(() => {
        setUrlState({
            spyId: selectContextSpyId
        })
    }, [
        selectContextSpyId
    ])
    
    useEffect(() => {
        const handle = async () => {
            if (readMonitorByIdQueryData === undefined){
                return
            }

            const spy = readMonitorByIdQueryData
            setContextLocation(spy.locations[0])

            setContextLocationSearchString(spy.locations[0].name)

            const convertedLaunchSettings = spyLaunchSettingsConvertFromApiValue(spy)
            setContextSpyLaunchSettings(convertedLaunchSettings)

            const convertedContextFilters = filtersConvertFromApi(spy)
            setContextFilters(convertedContextFilters) 
        }

        handle()
    }, [
        readMonitorByIdQueryData
    ])
  
}
